import * as swcHelpers from '@swc/helpers';
import React__default from 'react';
import { useQuery } from '@grandvisionhq/graphql';
import { useIntl } from '@grandvisionhq/state';
import GET_RECOMMENDATIONS from './operations/queries/get-recommendations.js';
import { RecommendationListMiniCart } from './RecommendationListMiniCart.js';
import { RecommendationListPage } from './RecommendationListPage.js';
import { mergeAndSortRecommendations } from './utils/merge-and-sort-recommendations.js';

const componentMap = {
    page: RecommendationListPage,
    minicart: RecommendationListMiniCart
};
const requestForPage = {
    maximumBannerRecommendations: 0,
    maximumProductRecommendations: 4
};
const RecommendationListContainer = ({ skus , recommendationContext , formatProductUrl , maxItems , layout ='minicart' ,  })=>{
    var ref, ref1;
    const { getLabel , locale  } = useIntl();
    const { data , loading , error  } = useQuery(GET_RECOMMENDATIONS, {
        variables: {
            input: swcHelpers.objectSpread({
                skus,
                recommendationContext,
                locale
            }, layout === 'page' ? requestForPage : null)
        }
    });
    const labels = React__default.useMemo(()=>({
            title: getLabel('products.recommendationList.title')
        })
    , [
        getLabel
    ]);
    if (error || !loading && !data) {
        return null;
    }
    const recommendedProducts = (data === null || data === void 0 ? void 0 : (ref = data.getRecommendations) === null || ref === void 0 ? void 0 : ref.recommendedProducts) || [];
    const recommendedBanners = (data === null || data === void 0 ? void 0 : (ref1 = data.getRecommendations) === null || ref1 === void 0 ? void 0 : ref1.recommendedBanners) || [];
    const recommendations = mergeAndSortRecommendations(recommendedProducts, recommendedBanners, {
        maxItems
    });
    if (!loading && !recommendations.length) {
        return null;
    }
    const Component = componentMap[layout] || RecommendationListMiniCart;
    return /*#__PURE__*/ React__default.createElement(Component, {
        labels: labels,
        recommendations: recommendations,
        locale: locale,
        formatProductUrl: formatProductUrl,
        className: `recommendation-list-${layout}-layout`
    });
};

export { RecommendationListContainer };
//# sourceMappingURL=RecommendationListContainer.js.map
